module.exports = __webpack_public_path__ + "img/industry-banner-01.34769d4d.png";